 <template>
  <main
    v-if="galleryCategoryData != null"
    id="blogsSection"
    class="width80 margin-auto"
  >
    <introduction
      :title="getTitle()"
      :summary="galleryCategoryData.intro.title"
      :image="$root.baseImageUrl + galleryCategoryData.intro.image"
      :routes="routes"
    >
      <p class="slotElements">
        {{ galleryCategoryData.intro.text }}
      </p>
    </introduction>
    <section id="galleries">
      <!-- " @click="goToRoute(`/galleries/${item.id}/${$root.slugGenerator(item.name)}`)" -->
       <div 
       :key="index"
       v-for="(item, index) in galleryCategoryData.galleryCategories"
         class="width100 margin-auto  justify-content-center">
       <router-link 
       target="_blank"
        :id="item.id" 
        :to="{
              name: 'galleriesFront',
              params: {id:item.id, slug:$root.slugGenerator(item.name) }
            }"> 
             <img :src="$root.baseImageUrl + item.image" :alt="item.name" />
            <h3>{{ item.name}}</h3>
          </router-link> 
          </div>
      <!-- <div
      @click="setIndex(item.id)"
        v-for="(item, index) in galleryCategoryData.galleryCategories"
        :key="index"
      >
        <img :src="$root.baseImageUrl + item.image" :alt="item.name" />
        <h3>{{ item.name}}</h3>
      </div> -->
    </section>
    <!-- <vue-gallery-slideshow
      :images="images"
      :index="index"
      @close="index = null"
    ></vue-gallery-slideshow> -->
  </main>
  <loader v-else />
</template>
<script>
import VueGallerySlideshow from "vue-gallery-slideshow";

import introduction from "@/components/front/shared/introduction.vue";
import Loader from "@/components/front/shared/loader.vue";
import router from "../../router";
//import galleries from "../front/galleries.vue"
//import doubleLine from "@/components/front/shared/doubleLine.vue";
export default {
  components: {
    Loader,
    introduction,
    VueGallerySlideshow,
    router,
    //galleries
},
  data() {
    return {
      images: [],
      index:null,
      id:null,
      routes: [{ route: "", routeTitle_fa: "گالری", routeTitle_en: "Gallery" }],
    };
  },

  metaInfo() {
    return {
      title: this.$cookie.get("ltrTheme")
        ? "Gallery-margarin"
        : "مارگارین - تصویر ها",
      meta: [
        {
          name: "description",
          content: this.galleryCategoryData ? this.galleryCategoryData.intro.text : false,
        },
        {
          property: "og:title",
          content: this.$cookie.get("ltrTheme")
            ? "Gallery-margarin"
            : "مارگارین - تصویر ها",
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  watch: {
    galleryCategoryData(newV) {
      let fakeThis = this;
      newV.galleryCategories.forEach((element) => {
        fakeThis.images.push(fakeThis.$root.baseImageUrl + element.image);
      });
    },
  },
  computed: {
    galleryCategoryData() {
      return this.$store.getters.getGalleryCategoryData;
    },
  },
  mounted() {
    if (this.galleryCategoryData == null) {
      this.checkRequest("getGalleryCategoryDataFromServer", null);
    }
  },

  methods: {
      // setIndex(index){
      //     this.index=index
      // },
       setIndex(id){
           this.id=id
       },
    getTitle() {
      if (this.$cookie.get("ltrTheme")) return "Galleries Archive";
      else return "آرشیو تصاویر";
    },
    goToRoute(path){
      if(window.innerWidth<1000)
      this.$router.push(path)
    }
  },
};
</script>
<style>
.vgs{
    z-index: 100000000 !important;
}</style> 
